module.exports = __webpack_public_path__ + "static/img/product_banner_48_zh.c6b6591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_48_zh.png
// module id = DANH
// module chunks = 34